import { Loader2, Plus } from 'lucide-react'
import { FabComponent } from '@/modules/shared/components/fab.component'
import { BottomMenuComponent } from '@/modules/shared/components/bottom-menu.component'
import { AlertDialog, AlertDialogContent, AlertDialogDescription, AlertDialogTitle } from '@/modules/shared/components/ui/alert-dialog'
import { OrderFilterSearchComponent } from '../components/order-filter/order-filter.component'
import { OrderList } from '../components/order-list/order-list.component'
import { OrderStatusLegendComponent } from '../components/order-status-legend/order-status-legend.component'
import { ORDER_FAB } from '../constants/menu-actions-order-component.constant'
import { useOrderSearch } from '../hooks/use-order-search.hook'
import { Layout } from '../../shared/layouts/layout'
import { ModalOrderReplicateComponent } from '../components/shared/modal-order-replicate.component'
import { ModalPDFDownloadComponent } from '../components/shared/pdf-download/modal-pdf-download.component'

export type TOrderSearchPage = ReturnType<typeof useOrderSearch>




export function OrderSearchPage() {


	const orderSearchHook = useOrderSearch()

	const { orders, totalRecords, orderSelected, isTransmiting, hasMore, isLoadingMore, loadMoreOrders, handleSelectOrderToStartActions, handleViewOrder, handleSelectActionToStart } = orderSearchHook
	const renderEmptyState = () => (
		<div className="w-full text-center flex-1 h-screen">
			<p className="text-sm mt-40">
				Lista de pedidos está vazia, inclua um pedido.
			</p>
		</div>
	)

	const renderOrderStats = () => (
		<div className="mt-4 mb-3 px-2 flex items-center justify-between gap-2">
			<p className="text-sm text-gray-600">
				{totalRecords > 0 ? (
					<>
						{orders.length} de {totalRecords} pedidos
					</>
				) : (
					orders.length === 1
						? `${orders.length} pedido encontrado`
						: `${orders.length} pedidos encontrados`
				)}
			</p>
			<OrderStatusLegendComponent />
		</div>
	)

	const renderFab = () => {
		if (orderSelected) {
			return (
				<FabComponent
					bottomMenuOffset={true}
					items={ORDER_FAB.map((item) => ({
						id: item.id,
						icon: item.icon,
						type: item.type,
						disabled: orderSelected?.fkStatus !== "10" &&
							(item.type === 'edit' || item.type === 'delete' || item.type === 'transmit'),
						label: item.label,
					}))}
					action={handleSelectActionToStart}
				/>
			)
		}

		return (
			<FabComponent
				bottomMenuOffset={true}
				className="bottom-10"
				items={[
					{
						id: '7',
						icon: Plus,
						type: 'add',
						disabled: false,
						label: 'Adicionar',
					},
				]}
				action={handleSelectActionToStart}
			/>
		)
	}


	return (
		<>
			<Layout pageTitle="Pedidos" handleGoBack={orderSearchHook.handleBackPage}>
				<div>
					<AlertDialog open={isTransmiting}>
						<AlertDialogContent className="flex flex-col items-center flex-1 top-[95%] m-0 pb-28 md:pb-40 md:pt-10 lg:p-8 w-screen max-w-full lg:max-w-lg mb-2 lg:top-[50%] rounded-t-2xl">
							<Loader2 className="animate-spin text-primary size-10 text-center" />
							<AlertDialogTitle className="hidden">Transmitindo Pedido</AlertDialogTitle>
							<AlertDialogDescription className="text-center mb-4">
								Transmitindo pedido, por favor aguarde...
							</AlertDialogDescription>
						</AlertDialogContent>
					</AlertDialog>
					<OrderFilterSearchComponent />
					{orders && renderOrderStats()}
					{orders && orders.length === 0 && renderEmptyState()}
					{orders !== undefined && (
						<OrderList
							orders={orders}
							isTransmissionPage={false}
							selectedOrderId={orderSelected?.idPedidoCel?.toString()}
							onSelectOrder={handleSelectOrderToStartActions}
							onViewOrder={handleViewOrder}
							hasMore={hasMore}
							isLoadingMore={isLoadingMore}
							onLoadMore={loadMoreOrders}
						/>
					)}
					{renderFab()}
					<BottomMenuComponent />
				</div>
				<ModalPDFDownloadComponent
					isOpen={
						orderSearchHook.typeConfirmationModal === 'pdf' &&
						orderSearchHook.isOpenModal
					}
					onClose={orderSearchHook.handleCloseModal}
				/>

				<ModalOrderReplicateComponent
					isOpen={
						orderSearchHook.typeConfirmationModal === 'replicate' &&
						orderSearchHook.isOpenModal
					}
					onClose={orderSearchHook.handleCloseModal}
				/>
			</Layout>

		</>
	)
}
